import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faAngleLeft, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import { toast } from 'react-hot-toast';

function Security({securityBar, toggleSecurityBar }) {
    const [cpass, setCpass] = useState();
    const [pass1, setPass1] = useState();
    const [pass2, setPass2] = useState();
    const [error, setError] = useState(false);
    const [error1, setError1] = useState(false);
    const [errorValue, setErrorValue] = useState();
    const [errorValue1, setErrorValue1] = useState();
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(true);
    //OPEN
    const [see, setSee] = useState(false);
    const [see1, setSee1] = useState(false);
    const [see2, setSee2] = useState(false);
    useEffect(() => {
        if(cpass && pass1 && pass2){
          setDisable(false);
        }else{
          setDisable(true);
        }
      }, [cpass, pass1, pass2]);
    function validatePassword (value){
        setPass1(value);
        if (value.length < 8) {
            setError(true);
            setErrorValue("Password must be at least 8 characters long.");
        } else if (!/[A-Z]/.test(value)) {
            setError(true);
            setErrorValue("Password must contain at least one uppercase letter.");
        } else if (!/[a-z]/.test(value)) {
            setError(true);
            setErrorValue("Password must contain at least one lowercase letter.");
        } else if (!/[0-9]/.test(value)) {
            setError(true);
            setErrorValue("Password must contain at least one number.");
        } else {
            setError(false);
            setErrorValue("");
        }
    }
    function validateConfirm (value){
        setPass2(value);
        if (value !== pass1) {
            setError1(true);
            setErrorValue1("Passwords do not match.");
        } else {
            setError1(false);
            setErrorValue1("");
        }
    }
    const ValidateSave = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/profile.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ passwordupdate: true, cpass: cpass, pass1: pass1, pass2: pass2})
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            setLoading(false);
            toggleSecurityBar();
            toast.success(data.result);
          }else{
            toast.error(data.message);
          }
        })
        .catch(err => {
          console.error(err)
          setLoading(false);
          toast.error('There was an issue processing your deposit.')
        })
      }
    return (
    <div className={`notifybar ${securityBar ? "active" : null}`}>
        <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center" style={{cursor: 'pointer'}}>
                <FontAwesomeIcon icon={faAngleLeft} style={{color: 'white', cursor: 'pointer', fontSize: '14px'}} onClick={() => {toggleSecurityBar()}}/>
                <p className="mb-0 fw-semibold ms-3 text-white">Security Settings </p>
            </div> 
            <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '20px'}} onClick={() => {toggleSecurityBar()}}/>
        </div>
        <div className="sidebar-navbar" style={{height: 'auto'}}>
            <p className="mb-0 text-white fw-bold">Password</p>
            <p className="mb-0 text-secondary fw-bold" style={{fontSize: '14px'}}>Edit your sign-in password.</p>
            <label className="fw-semibold mt-4 mb-2" style={{fontSize: '14px'}}>Current password:</label>
            <div className="d-flex align-items-center form-control justify-content-between py-2 pe-2">
                <input 
                  type={see?"text":"password"}
                  placeholder="Password (min. of 8 characters)"
                  className="inputNone"
                  value={cpass}
                  onChange={(e) => setCpass(e.target.value)}
                />
                <FontAwesomeIcon icon={(see === false)?faEye:faEyeSlash} className="ms-2" style={{fontSize: '12px'}} onClick={() => {
                      setSee(see === true ? false : true);
                    }}/>
            </div>
            <label className="fw-semibold mt-3 mb-2" style={{fontSize: '14px'}}>New password:</label>
            <div className="d-flex align-items-center form-control justify-content-between py-2 pe-2">
                <input 
                  type={see1?"text":"password"}
                  placeholder="Your new password (min. of 8 characters)"
                  className="inputNone"
                  value={pass1}
                  onChange={(e) => validatePassword(e.target.value)}
                />
                <FontAwesomeIcon icon={(see1 === false)?faEye:faEyeSlash} className="ms-2" style={{fontSize: '12px'}} onClick={() => {
                      setSee1(see1 === true ? false : true);
                    }}/>
            </div>
            {error && (
                <p className="mb-0 text-danger fs-7 mt-1">{errorValue}</p>
            )}
            <label className="fw-semibold mt-3 mb-2" style={{fontSize: '14px'}}>Confirm new password:</label>
            <div className="d-flex align-items-center form-control justify-content-between py-2 pe-2">
                <input 
                  type={see2?"text":"password"}
                  placeholder="Retype your new password"
                  className="inputNone"
                  value={pass2}
                  onChange={(e) => validateConfirm(e.target.value)}
                />
                <FontAwesomeIcon icon={(see2 === false)?faEye:faEyeSlash} className="ms-2" style={{fontSize: '12px'}} onClick={() => {
                    setSee2(see2 === true ? false : true);
                }}/>
            </div>
            {error1 && (
                <p className="mb-0 text-danger fs-7 mt-1">{errorValue1}</p>
            )}
            <div className={`myBtn w-100 text-center mt-5 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? ValidateSave : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
            {/* <p className="mb-0 text-white fw-bold mt-5">Delete account</p>
            <p className="mb-0 text-secondary fw-bold" style={{fontSize: '14px'}}>Once you delete your account, there is no going back. Please be certain.</p>
            <div className="myBtn bg-danger w-100 text-center mt-5" style={{paddingTop: '12px',paddingBottom: '12px'}}>Delete your account</div> */}
        </div>
    </div>
    )
}

export default Security